// Adapted from common-shell/src/core/escape.ts: one Escape stack, one
// document listener. The topmost handler gets the key; returning `false`
// declines and passes it down. Never add a document keydown listener for
// Escape anywhere else (admin-ui-component skill).
/** Return `false` to decline and pass the key to the next layer down. */
type EscapeHandler = (event: KeyboardEvent) => boolean | undefined

const stack: EscapeHandler[] = []
let listening = false

function onKeyDown(event: KeyboardEvent) {
  if (event.key !== 'Escape' || event.defaultPrevented) return
  for (let i = stack.length - 1; i >= 0; i--) {
    const handler = stack[i]
    if (handler && handler(event) !== false) {
      event.preventDefault()
      event.stopPropagation()
      return
    }
  }
}

/** Push a handler on top of the stack. Returns the release function. */
export function pushEscape(handler: EscapeHandler): () => void {
  stack.push(handler)
  if (!listening) {
    document.addEventListener('keydown', onKeyDown)
    listening = true
  }
  return () => {
    const index = stack.lastIndexOf(handler)
    if (index > -1) stack.splice(index, 1)
    if (stack.length === 0 && listening) {
      document.removeEventListener('keydown', onKeyDown)
      listening = false
    }
  }
}

/** Test helper: the number of active handlers. */
export const escapeDepth = () => stack.length
